import { APPROUTES, constants } from '../../../assets/constants/constants';
import CarouselSection from '../../common/CarouselSection';
import {useTranslation} from 'react-i18next';

const OtherSection = ({searchResult, addBookMark, deleteBookMark, type, data, keyword,catId}: any) => {
  const {t} = useTranslation();
  return (
    <>
      {keyword ? (
        <>
          {searchResult?.filter((item: any) => {
            return !item?.attributes?.tags;
          }).length > 0 && (
            <>
              <h2 className="text-3xl font-barlowLight mt-6"><span dangerouslySetInnerHTML={{ __html: (t('Common.otherSection')) }} /></h2>
              <CarouselSection
                type={type}
                data={searchResult?.filter((item: any) => {
                  return !item?.attributes?.tags;
                })}
                addBookMark={addBookMark}
                deleteBookMark={deleteBookMark}
                seeAll={true}
                filterTag={constants.others}
                from={APPROUTES.library}
                catId={catId}
              />
            </>
          )}
        </>
      ) : (
        <>
          {data?.filter((item: any) => {
            return !item?.attributes?.tags;
          }).length > 0 && (
            <>
              <h2 className="text-3xl font-barlowLight mt-6"><span dangerouslySetInnerHTML={{ __html: (t('Common.otherSection')) }} /></h2>
              <CarouselSection
                type={type}
                data={data?.filter((item: any) => {
                  return !item?.attributes?.tags;
                })}
                addBookMark={addBookMark}
                deleteBookMark={deleteBookMark}
                seeAll={true}
                filterTag={constants.others}
                from={APPROUTES.library}
                catId={catId}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default OtherSection;
